import React, { Component } from 'react';

class Image extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {



  }

  componentWillUnmount() {

    }



  render() {

  const ratioStyle = {

      paddingTop:(100 / (this.props.ratio))+'%'

    }
    const fluidStyle = {

      width:'100%',
      height:'100%'

    }

    const style = (this.props.fluid) ? fluidStyle : ratioStyle;

    return (
      <div className="Image" style={style}>
          <div className="Image-media" style={{backgroundImage:"url("+this.props.small+")"}} />
      </div>
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/js/components/Image/Image.jsx